import React, { useState } from "react";
import { FlyerDetailPageTabLayout } from "./flyer-detail-page-tab.styles";
import { FlyerDetailPageTabProps } from "./flyer-detail-page-tab.props";
import { FlyerDetailPageTabPagesList } from "../flyer-detail-page-tab-pages-list/flyer-detail-page-tab-pages-list.component";
import { OutlinedButton } from "../../../../../../../../components/form-controls/button/outlined-button/outlined-button.component";
import AddNewIcon from "../../../../../../../../components/icon/icons/add-new-icon.component";
import { FlyerDetailPageTabNoPagesMessage } from "../flyer-detail-page-tab-no-pages-message/flyer-detail-page-tab-no-pages-message.component";
import { DeleteConfirmationModal } from "../../../../../../../../components/modals/delete-confirmation-modal/delete-confirmation-modal.component";
import { Nullable } from "../../../../../../../../types/common";
import { FlyerDetailPageOverview } from "../../../../../../types/flyer-detail-data/flyer-detail-data.interface";

export const FlyerDetailPageTab = (props: FlyerDetailPageTabProps) => {
  const [pageToDelete, setPageToDelete] = useState<Nullable<FlyerDetailPageOverview>>(null);

  const onDeletePage = (page: FlyerDetailPageOverview) => setPageToDelete(page);

  const onConfirmDelete = () => {
    props.onDeletePage(pageToDelete!.id);
    setPageToDelete(null);
  };

  const onCancelDelete = () => setPageToDelete(null);

  return (
    <FlyerDetailPageTabLayout>
      <DeleteConfirmationModal
        isOpen={Boolean(pageToDelete)}
        onConfirm={onConfirmDelete}
        onCancel={onCancelDelete}
        description={pageToDelete?.name}
      />

      <FlyerDetailPageTabPagesList
        showIf={Boolean(props.pages?.length)}
        pages={props.pages}
        canDelete={props.canDelete}
        onDeletePage={onDeletePage}
        onClickPage={props.onClickPage}
      />

      <FlyerDetailPageTabNoPagesMessage showIf={!Boolean(props.pages?.length)} />

      <OutlinedButton onClick={props.onAddPage} disabled={!props.permissions.canEdit}>
        <AddNewIcon />
        &nbsp;Add Page
      </OutlinedButton>
    </FlyerDetailPageTabLayout>
  );
};
